/**
 * @file TaskGroupList.tsx
 * @description Список задач по группам срока (phase19.31, SC60):
 * «Просрочено · 2», «Сегодня · 3», «Завтра», «Позже», «Без срока»
 * (и «Выполненные» при включённом флажке). Блок на непрозрачной
 * поверхности (SC69), заголовок группы — подложкой шапки таблицы.
 */

import { Fragment } from "react";

import { LIST_FRAME_CLASS } from "../../ui/ListStates";
import type { ActivityDto } from "../../../lib/api-crm";
import type { TaskGroup } from "./task-groups";
import { TaskRow } from "./TaskRow";

interface Props {
  groups: TaskGroup<ActivityDto>[];
  timeZone: string;
  base: string;
  canComplete: (task: ActivityDto) => boolean;
  completingId: string | null;
  onComplete: (task: ActivityDto) => void;
  onOpen: (task: ActivityDto) => void;
}

export function TaskGroupList({ groups, timeZone, base, canComplete, completingId, onComplete, onOpen }: Props) {
  return (
    <div className={LIST_FRAME_CLASS}>
      {groups.map((group, index) => (
        <Fragment key={group.key}>
          <h2
            id={`tasks-group-${group.key}`}
            className={`type-caption bg-[var(--table-head-bg)] px-4 py-2 font-semibold text-on-surface-variant ${index > 0 ? "border-t border-[var(--border)]" : ""}`}
          >
            {group.label} · {group.items.length}
          </h2>
          <ul aria-labelledby={`tasks-group-${group.key}`} className="divide-y divide-[var(--border)]">
            {group.items.map((task) => (
              <TaskRow
                key={task.id}
                task={task}
                group={group.key}
                timeZone={timeZone}
                base={base}
                canComplete={canComplete(task)}
                completing={completingId === task.id}
                onComplete={() => onComplete(task)}
                onOpen={() => onOpen(task)}
              />
            ))}
          </ul>
        </Fragment>
      ))}
    </div>
  );
}
